import { createAction, props } from '@ngrx/store';
import { IUserProfile } from '../models';
export const profileStoreName = 'profile';

export const initializedHomeStoreAction = createAction(`[${profileStoreName}] Initialize Coventry store`);
export const apiErrorAction = createAction(`[${profileStoreName}] API Error`, props<{ method: string; error: string }>());

export const loadProfile = createAction(`[${profileStoreName}] Load Profile`);
export const getProfile = createAction(`[${profileStoreName}] Get Profile`, props<{ profile: IUserProfile }>());
export const clearProfile = createAction(`[${profileStoreName}] Clear Profile`);

export const saveUserProfile = createAction(`[${profileStoreName}] Save User Profile`, props<{ profile: IUserProfile }>());
export const saveUserProfileSuccess = createAction(`[${profileStoreName}] Save User Profile Success`);